import { render, staticRenderFns } from "./MasterView.vue?vue&type=template&id=8066c270"
import script from "./MasterView.vue?vue&type=script&lang=js"
export * from "./MasterView.vue?vue&type=script&lang=js"
import style0 from "./MasterView.vue?vue&type=style&index=0&id=8066c270&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports